// @flow
import {
  SET_TASK, TASK_LIST_RELOAD,
} from "./actionTypes";

const INIT_STATE = {
  isOpen: false,
  type: undefined,
  targetIdx: null,
  taskIdx: null,
  mode: null,
  taskToggle: false,
};

const Task = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_TASK:
      return {
        ...state,
        ...action.payload
      };
    case TASK_LIST_RELOAD:
      return {
        ...state,
        taskToggle: !state.taskToggle
      };
    default:
      return state;
  }
};

export default Task;